import React from 'react'
import ReactDOM from 'react-dom/client'
import BgmnApp from './BgmnApp'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BgmnApp />
  </React.StrictMode>,
)
